/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CandidateEmailMarkAsUnreadPathParams,
	CandidateEmailMarkAsUnreadRequest,
	CandidateEmailMarkAsUnreadResponse,
} from '../types/CandidateEmailMarkAsUnread'

/**
 * POST /candidates/:candidateId/emails/unread
 * @see backend/nexus/modules/Campaign/Http/Controllers/CandidateEmailController.php CandidateEmailController::markAsUnread
 */
export async function candidateEmailMarkAsUnread(
	candidateId: CandidateEmailMarkAsUnreadPathParams['candidateId'],
	data: CandidateEmailMarkAsUnreadRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateEmailMarkAsUnreadResponse>> {
	return axiosInstance.post(`/candidates/${candidateId}/emails/unread`, data, config)
}
